/* VYDA — Motion helpers
 * 1) Reveal on scroll: aggiunge `.is-visible` agli elementi con `.vyda-reveal`
 *    quando entrano nel viewport.
 * 2) Sticky observer: utility per rilevare quando un elemento è sticky-attivo
 *    (usata in product page buy-module e header).
 *
 * Rispetta prefers-reduced-motion: in quel caso applica subito `.is-visible`.
 */

(() => {
  'use strict';

  // Progressive enhancement: attiva gli stati hidden CSS (.vyda-reveal).
  // Senza JS, niente reveal, ma contenuto resta visibile (no broken UX).
  document.documentElement.classList.add('js-enabled');

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    const targets = document.querySelectorAll('.vyda-reveal, .vyda-reveal-children');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    // Initial check: anything already in/past viewport on load → mark visible immediately
    const viewportH = window.innerHeight;
    targets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < viewportH * 0.9) el.classList.add('is-visible');
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -4% 0px' }
    );

    targets.forEach((el) => {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });

    // Safety net: anything still hidden after 4s gets revealed
    setTimeout(() => {
      targets.forEach((el) => el.classList.add('is-visible'));
    }, 4000);
  }

  function initStickyDetector() {
    const targets = document.querySelectorAll('[data-vyda-sticky]');
    if (!targets.length || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const stickyEl = entry.target.nextElementSibling;
          if (!stickyEl) return;
          stickyEl.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    targets.forEach((el) => io.observe(el));
  }

  function init() {
    initReveal();
    initStickyDetector();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init dopo Shopify section render (Theme Editor preview)
  document.addEventListener('shopify:section:load', init);
})();
